module.exports = "https://coursera_assets.s3.amazonaws.com/images/73183c71c35184411bbdf0971533c176.jpg";